<template>
  <div class="flex flex-col gap-4">
    <TitlePrimary :title="$t('user.detail.title')" />
    <p class="text-sm text-gray-600">{{ $t('user.directory.readOnly') }}</p>
    <p v-if="loading">{{ $t('common.loading') }}</p>
    <p v-else-if="error" role="alert" class="text-red-500">{{ error }}</p>
    <dl v-else-if="user" class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-xl bg-white">
      <div v-for="field in fields" :key="field.key">
        <dt class="font-medium">{{ $t(`user.fields.${field.key}`) }}</dt>
        <dd>{{ field.value || '-' }}</dd>
      </div>
    </dl>
    <RouterLink to="/user" class="underline">{{ $t('user.directory.back') }}</RouterLink>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import TitlePrimary from '@/components/title/title-primary.vue';

const route = useRoute();
const { t } = useI18n();
const user = ref(null);
const loading = ref(false);
const error = ref('');
const fields = computed(() => [
  { key: 'name', value: `${user.value?.name || ''} ${user.value?.surname || ''}`.trim() },
  { key: 'email', value: user.value?.email },
  { key: 'role', value: user.value?.roles?.map(role => t(`common.requestTypes.${role.name}`)).join(', ') },
  { key: 'status', value: user.value?.status ? t(`common.requestStatus.${user.value.status}`) : '-' },
  // Permiso "Ver todas las incidencias" (ADS-0122): dato de consulta, como el rol o el estado
  { key: 'seesAllRequests', value: user.value ? t(user.value.sees_all_requests ? 'common.yes' : 'common.no') : '' },
]);

let requestVersion = 0;
const fetchUser = async () => {
  const version = ++requestVersion;
  user.value = null;
  loading.value = true;
  error.value = '';
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/directory/${route.params.id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, Accept: 'application/json' },
    });
    if (version === requestVersion) user.value = response.data.value;
  } catch {
    if (version === requestVersion) error.value = t('user.directory.unavailable');
  } finally {
    if (version === requestVersion) loading.value = false;
  }
};
onMounted(fetchUser);
watch(() => route.params.id, fetchUser);
</script>
